/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import dayjs from "dayjs";
import { isValidDayjsValue } from "./isValidDayjsValue";

export const isValidCustomDateRange = (from, to) =>
  isValidDayjsValue(from) &&
  isValidDayjsValue(to) &&
  !dayjs(from).isAfter(dayjs(to), "day");
